import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import ProductContext from "./context";
import { useNavigate } from "react-router-dom";

export const useProductManager = () => {
  const navigate = useNavigate();
  const [request, setRequest] = useState({
    loading: true,
    data: [],
    page: 0,
    limit: 100,
  });

  const getProducts = useCallback(async () => {
    const mData = { ...request };
    try {
      request.loading = true;
      //showLoading();
      const { data: response, error } = await axios.get(
        `/products?&page=${request.page + 1}&limit=${request.limit}`,
      );

      if (error) throw new Error(error);

      const formattedData = response.data.map(({ ...p }, index) => ({
        ...p,
        id: p._id,
        date: new Date(p.createdAt).toLocaleString(),
        updatedAt: new Date(p.updatedAt).toLocaleString(),
        showDetails: () => navigate(`./${p._id}`),
      }));

      Object.assign(mData, { ...response, data: formattedData });
    } catch (e) {
      console.log(e);
      mData.data = [];
    } finally {
      mData.loading = false;
      await sleep(1000);
      setRequest(mData);
    }
  }, [request.page, request.limit]);

  const onNextPage = ({ page, pageSize }) => {
    if (request.loading) return;
    setRequest((o) => ({ ...o, page, loading: true, limit: pageSize }));
  };

  useEffect(() => {
    async function fetchdata() {
      return getProducts();
    }

    fetchdata();
    return () => {};
  }, [getProducts]);

  return {
    request,
    getProducts,
    onNextPage,
  };
};

export const useProduct = () => useContext(ProductContext);
